 
import API from "../../../api/axiosClient";
import {
    ChangePasswordDto,
    CreateUserDto,
    GroupResponseDto,
    LoginDto,
    LoginResponseDto,
    RegisterDto,
    RegisterResponseDto,
    SendOtpDto,
    VerifyOtpDto
} from "../types/authTypes";

export const login = async (
    data: LoginDto
) => {

    const response =
        await API.post<LoginResponseDto>(
            "Auth/login",
            data
        );

    return response.data;
};
export const register = async (
    data: RegisterDto
) => {

    const response =
        await API.post<RegisterResponseDto>(
            "/Auth/register",
            data
        );

    return response.data;
};
export const sendPhoneOtp = async (
    data: SendOtpDto
) => {

    const response =
        await API.post(
            "/Auth/send-phone-otp",
            data
        );

    return response.data;
};
export const verifyPhoneOtp = async (
    data: VerifyOtpDto
) => {

    const response =
        await API.post(
            "/Auth/verify-phone-otp",
            data
        );

    return response.data;
};
export const sendEmailOtp = async (
    data: SendOtpDto
) => {
    const response = await API.post(
        "/Auth/send-email-otp",
        data
    );

    return response.data;
};

export const verifyEmailOtp = async (
    data: VerifyOtpDto
) => {
    const response = await API.post(
        "/Auth/verify-email",
        data
    );

    return response.data;
};

export const forgotPassword = async (
    email: string
) => {

    const response = await API.post(
        "/Auth/forgot-password",
        {
            email
        }
    );

    return response.data;

};

export const createUser = async (
    data: CreateUserDto
) => {

    const response = await API.post(
        "/Auth/Create-user",
        data
    );

    return response.data;

};

export const resetPassword = async (
    token: string,
    newPassword: string
) => {

    const response = await API.post(
        "/Auth/reset-password",
        {
            token,
            newPassword
        }
    );

    return response.data;

};
export const getMyGroups = async () => {
    const response =
        await API.get<GroupResponseDto>("/Auth/my-groups");

    return response.data;
};
export const getProfile = async () => {

    const response =
        await API.get("/Auth/profile");

    return response.data;

};
export const changePassword = async (
    data: ChangePasswordDto
) => {

    const response = await API.post(
        "/Auth/change-password",
        data
    );

    return response.data;

};